module.exports = "\n<p class=\"offline-tip\" *ngIf=\"isOffline\" [style.top.px]=\"top\" (click)=\"isOffline = false\">当前无网络连接</p>\n<router-outlet></router-outlet>\n<!--<app-footer></app-footer>-->\n"


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main